/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { DeliverObjectDependencyDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Create
 */
export const postDeliverObjectDependency = (
  deliverObjectDependencyDto: DeliverObjectDependencyDto,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDependencyDto>({
    url: `/deliver-object-dependency`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: deliverObjectDependencyDto,
    signal,
  });
};

export const getPostDeliverObjectDependencyMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDeliverObjectDependency>>,
    TError,
    { data: DeliverObjectDependencyDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDeliverObjectDependency>>,
  TError,
  { data: DeliverObjectDependencyDto },
  TContext
> => {
  const mutationKey = ["postDeliverObjectDependency"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDeliverObjectDependency>>,
    { data: DeliverObjectDependencyDto }
  > = (props) => {
    const { data } = props ?? {};

    return postDeliverObjectDependency(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDeliverObjectDependencyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDeliverObjectDependency>>
>;
export type PostDeliverObjectDependencyMutationBody =
  DeliverObjectDependencyDto;
export type PostDeliverObjectDependencyMutationError = void;

/**
 * @summary Create
 */
export const usePostDeliverObjectDependency = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDeliverObjectDependency>>,
      TError,
      { data: DeliverObjectDependencyDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDeliverObjectDependency>>,
  TError,
  { data: DeliverObjectDependencyDto },
  TContext
> => {
  const mutationOptions =
    getPostDeliverObjectDependencyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get By Deliver Object
 */
export const getDeliverObjectDependencyDeliverObjectDeliverObjectId = (
  deliverObjectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDependencyDto[]>({
    url: `/deliver-object-dependency/deliver-object/${deliverObjectId}`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfiniteQueryKey =
  (deliverObjectId?: number) => {
    return [
      "infinite",
      `/deliver-object-dependency/deliver-object/${deliverObjectId}`,
    ] as const;
  };

export const getGetDeliverObjectDependencyDeliverObjectDeliverObjectIdQueryKey =
  (deliverObjectId?: number) => {
    return [
      `/deliver-object-dependency/deliver-object/${deliverObjectId}`,
    ] as const;
  };

export const getGetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<
          typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
        >
      >
    >,
    TError = void,
  >(
    deliverObjectId: number,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfiniteQueryKey(
        deliverObjectId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
        >
      >
    > = ({ signal }) =>
      getDeliverObjectDependencyDeliverObjectDeliverObjectId(
        deliverObjectId,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!deliverObjectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<
        ReturnType<
          typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
    >
  >;
export type GetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfiniteQueryError =
  void;

export function useGetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Deliver Object
 */

export function useGetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectDependencyDeliverObjectDeliverObjectIdInfiniteQueryOptions(
      deliverObjectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectDependencyDeliverObjectDeliverObjectIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
    >,
    TError = void,
  >(
    deliverObjectId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDeliverObjectDependencyDeliverObjectDeliverObjectIdQueryKey(
        deliverObjectId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
        >
      >
    > = ({ signal }) =>
      getDeliverObjectDependencyDeliverObjectDeliverObjectId(
        deliverObjectId,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!deliverObjectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDeliverObjectDependencyDeliverObjectDeliverObjectIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
    >
  >;
export type GetDeliverObjectDependencyDeliverObjectDeliverObjectIdQueryError =
  void;

export function useGetDeliverObjectDependencyDeliverObjectDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyDeliverObjectDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyDeliverObjectDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Deliver Object
 */

export function useGetDeliverObjectDependencyDeliverObjectDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyDeliverObjectDeliverObjectId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectDependencyDeliverObjectDeliverObjectIdQueryOptions(
      deliverObjectId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get By Predecessor
 */
export const getDeliverObjectDependencyPredecessorDeliverObjectId = (
  deliverObjectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDependencyDto[]>({
    url: `/deliver-object-dependency/predecessor/${deliverObjectId}`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectDependencyPredecessorDeliverObjectIdInfiniteQueryKey =
  (deliverObjectId?: number) => {
    return [
      "infinite",
      `/deliver-object-dependency/predecessor/${deliverObjectId}`,
    ] as const;
  };

export const getGetDeliverObjectDependencyPredecessorDeliverObjectIdQueryKey = (
  deliverObjectId?: number,
) => {
  return [`/deliver-object-dependency/predecessor/${deliverObjectId}`] as const;
};

export const getGetDeliverObjectDependencyPredecessorDeliverObjectIdInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
      >
    >,
    TError = void,
  >(
    deliverObjectId: number,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDeliverObjectDependencyPredecessorDeliverObjectIdInfiniteQueryKey(
        deliverObjectId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
      >
    > = ({ signal }) =>
      getDeliverObjectDependencyPredecessorDeliverObjectId(
        deliverObjectId,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!deliverObjectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDeliverObjectDependencyPredecessorDeliverObjectIdInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
    >
  >;
export type GetDeliverObjectDependencyPredecessorDeliverObjectIdInfiniteQueryError =
  void;

export function useGetDeliverObjectDependencyPredecessorDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyPredecessorDeliverObjectId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyPredecessorDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyPredecessorDeliverObjectId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyPredecessorDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyPredecessorDeliverObjectId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Predecessor
 */

export function useGetDeliverObjectDependencyPredecessorDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyPredecessorDeliverObjectId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectDependencyPredecessorDeliverObjectIdInfiniteQueryOptions(
      deliverObjectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectDependencyPredecessorDeliverObjectIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
    >,
    TError = void,
  >(
    deliverObjectId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDeliverObjectDependencyPredecessorDeliverObjectIdQueryKey(
        deliverObjectId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
      >
    > = ({ signal }) =>
      getDeliverObjectDependencyPredecessorDeliverObjectId(
        deliverObjectId,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!deliverObjectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDeliverObjectDependencyPredecessorDeliverObjectIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
    >
  >;
export type GetDeliverObjectDependencyPredecessorDeliverObjectIdQueryError =
  void;

export function useGetDeliverObjectDependencyPredecessorDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyPredecessorDeliverObjectId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyPredecessorDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyPredecessorDeliverObjectId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencyPredecessorDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyPredecessorDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyPredecessorDeliverObjectId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Predecessor
 */

export function useGetDeliverObjectDependencyPredecessorDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyPredecessorDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliverObjectDependencyPredecessorDeliverObjectId
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectDependencyPredecessorDeliverObjectIdQueryOptions(
      deliverObjectId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get By Project
 */
export const getDeliverObjectDependencyProjectProjectId = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDependencyDto[]>({
    url: `/deliver-object-dependency/project/${projectId}`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectDependencyProjectProjectIdInfiniteQueryKey = (
  projectId?: number,
) => {
  return [
    "infinite",
    `/deliver-object-dependency/project/${projectId}`,
  ] as const;
};

export const getGetDeliverObjectDependencyProjectProjectIdQueryKey = (
  projectId?: number,
) => {
  return [`/deliver-object-dependency/project/${projectId}`] as const;
};

export const getGetDeliverObjectDependencyProjectProjectIdInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
    >,
    TError = void,
  >(
    projectId: number,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDeliverObjectDependencyProjectProjectIdInfiniteQueryKey(projectId);

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
    > = ({ signal }) =>
      getDeliverObjectDependencyProjectProjectId(projectId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!projectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDeliverObjectDependencyProjectProjectIdInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
  >;
export type GetDeliverObjectDependencyProjectProjectIdInfiniteQueryError = void;

export function useGetDeliverObjectDependencyProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
          >,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
          >,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Project
 */

export function useGetDeliverObjectDependencyProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectDependencyProjectProjectIdInfiniteQueryOptions(
      projectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectDependencyProjectProjectIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeliverObjectDependencyProjectProjectIdQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
  > = ({ signal }) =>
    getDeliverObjectDependencyProjectProjectId(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectDependencyProjectProjectIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
>;
export type GetDeliverObjectDependencyProjectProjectIdQueryError = void;

export function useGetDeliverObjectDependencyProjectProjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
          >,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyProjectProjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
          >,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyProjectProjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Project
 */

export function useGetDeliverObjectDependencyProjectProjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencyProjectProjectId>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectDependencyProjectProjectIdQueryOptions(
      projectId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get By Successor
 */
export const getDeliverObjectDependencySuccessorDeliverObjectId = (
  deliverObjectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDependencyDto[]>({
    url: `/deliver-object-dependency/successor/${deliverObjectId}`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectDependencySuccessorDeliverObjectIdInfiniteQueryKey =
  (deliverObjectId?: number) => {
    return [
      "infinite",
      `/deliver-object-dependency/successor/${deliverObjectId}`,
    ] as const;
  };

export const getGetDeliverObjectDependencySuccessorDeliverObjectIdQueryKey = (
  deliverObjectId?: number,
) => {
  return [`/deliver-object-dependency/successor/${deliverObjectId}`] as const;
};

export const getGetDeliverObjectDependencySuccessorDeliverObjectIdInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
      >
    >,
    TError = void,
  >(
    deliverObjectId: number,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDeliverObjectDependencySuccessorDeliverObjectIdInfiniteQueryKey(
        deliverObjectId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
      >
    > = ({ signal }) =>
      getDeliverObjectDependencySuccessorDeliverObjectId(
        deliverObjectId,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!deliverObjectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDeliverObjectDependencySuccessorDeliverObjectIdInfiniteQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
    >
  >;
export type GetDeliverObjectDependencySuccessorDeliverObjectIdInfiniteQueryError =
  void;

export function useGetDeliverObjectDependencySuccessorDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencySuccessorDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencySuccessorDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Successor
 */

export function useGetDeliverObjectDependencySuccessorDeliverObjectIdInfinite<
  TData = InfiniteData<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
    >
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectDependencySuccessorDeliverObjectIdInfiniteQueryOptions(
      deliverObjectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectDependencySuccessorDeliverObjectIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
    >,
    TError = void,
  >(
    deliverObjectId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDeliverObjectDependencySuccessorDeliverObjectIdQueryKey(
        deliverObjectId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
      >
    > = ({ signal }) =>
      getDeliverObjectDependencySuccessorDeliverObjectId(
        deliverObjectId,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!deliverObjectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDeliverObjectDependencySuccessorDeliverObjectIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
    >
  >;
export type GetDeliverObjectDependencySuccessorDeliverObjectIdQueryError = void;

export function useGetDeliverObjectDependencySuccessorDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencySuccessorDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliverObjectDependencySuccessorDeliverObjectId
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencySuccessorDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Successor
 */

export function useGetDeliverObjectDependencySuccessorDeliverObjectId<
  TData = Awaited<
    ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
  >,
  TError = void,
>(
  deliverObjectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDeliverObjectDependencySuccessorDeliverObjectId>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDeliverObjectDependencySuccessorDeliverObjectIdQueryOptions(
      deliverObjectId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update
 */
export const putDeliverObjectDependencyId = (
  id: number,
  deliverObjectDependencyDto: DeliverObjectDependencyDto,
) => {
  return customInstance<DeliverObjectDependencyDto>({
    url: `/deliver-object-dependency/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: deliverObjectDependencyDto,
  });
};

export const getPutDeliverObjectDependencyIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putDeliverObjectDependencyId>>,
    TError,
    { id: number; data: DeliverObjectDependencyDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putDeliverObjectDependencyId>>,
  TError,
  { id: number; data: DeliverObjectDependencyDto },
  TContext
> => {
  const mutationKey = ["putDeliverObjectDependencyId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putDeliverObjectDependencyId>>,
    { id: number; data: DeliverObjectDependencyDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putDeliverObjectDependencyId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutDeliverObjectDependencyIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putDeliverObjectDependencyId>>
>;
export type PutDeliverObjectDependencyIdMutationBody =
  DeliverObjectDependencyDto;
export type PutDeliverObjectDependencyIdMutationError = void;

/**
 * @summary Update
 */
export const usePutDeliverObjectDependencyId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putDeliverObjectDependencyId>>,
      TError,
      { id: number; data: DeliverObjectDependencyDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putDeliverObjectDependencyId>>,
  TError,
  { id: number; data: DeliverObjectDependencyDto },
  TContext
> => {
  const mutationOptions =
    getPutDeliverObjectDependencyIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Id
 */
export const getDeliverObjectDependencyId = (
  id: number,
  signal?: AbortSignal,
) => {
  return customInstance<DeliverObjectDependencyDto>({
    url: `/deliver-object-dependency/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetDeliverObjectDependencyIdInfiniteQueryKey = (
  id?: number,
) => {
  return ["infinite", `/deliver-object-dependency/${id}`] as const;
};

export const getGetDeliverObjectDependencyIdQueryKey = (id?: number) => {
  return [`/deliver-object-dependency/${id}`] as const;
};

export const getGetDeliverObjectDependencyIdInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
  >,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeliverObjectDependencyIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
  > = ({ signal }) => getDeliverObjectDependencyId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectDependencyIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
>;
export type GetDeliverObjectDependencyIdInfiniteQueryError = void;

export function useGetDeliverObjectDependencyIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
  >,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
  >,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
  >,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetDeliverObjectDependencyIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
  >,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectDependencyIdInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeliverObjectDependencyIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeliverObjectDependencyIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
  > = ({ signal }) => getDeliverObjectDependencyId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliverObjectDependencyIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
>;
export type GetDeliverObjectDependencyIdQueryError = void;

export function useGetDeliverObjectDependencyId<
  TData = Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyId<
  TData = Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
          TError,
          Awaited<ReturnType<typeof getDeliverObjectDependencyId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDeliverObjectDependencyId<
  TData = Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetDeliverObjectDependencyId<
  TData = Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDeliverObjectDependencyId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDeliverObjectDependencyIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteDeliverObjectDependencyId = (id: number) => {
  return customInstance<boolean>({
    url: `/deliver-object-dependency/${id}`,
    method: "DELETE",
  });
};

export const getDeleteDeliverObjectDependencyIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDeliverObjectDependencyId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDeliverObjectDependencyId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteDeliverObjectDependencyId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDeliverObjectDependencyId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDeliverObjectDependencyId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDeliverObjectDependencyIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDeliverObjectDependencyId>>
>;

export type DeleteDeliverObjectDependencyIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteDeliverObjectDependencyId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDeliverObjectDependencyId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDeliverObjectDependencyId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteDeliverObjectDependencyIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
